<template>
    <div class="img-practice-fiscan">
        <div class="term-item">
            <div class="term-title">设备型号</div>
            <div class="term-content">
                <label v-for="item in fiscanProductDropdown"
                       :class="{'active': form.productIds.indexOf(item.id) > -1}"
                       :key="item.id">
                    <span>{{item.value}}</span>
                    <input type="checkbox" v-model="form.productIds" :value="item.id" @change="getStock">
                </label>
            </div>
        </div>

        <div class="term-item">
            <div class="term-title">违禁品数量</div>
            <div class="term-content">
                <label v-for="id in tipCountDropdown"
                       :class="{'active': form.tipCounts.indexOf(id) > -1}"
                       :key="id">
                    <span style="letter-spacing: 2px">{{id}}个</span>
                    <input type="checkbox" v-model="form.tipCounts" :value="id" @change="getStock">
                </label>
            </div>
        </div>

        <div class="term-item">
            <div class="term-title">知识点</div>
            <div class="term-content">
                <div class="danger-category" v-for="item in imageDictionary" :key="item.id">
                    <h5>{{ item.name }}</h5>
                    <template v-for="v in item.children">
                        <label class="label"
                               v-if="v.size"
                               :class="{'active': form.knowledges.indexOf(v.id) > -1, 'disabled': !v.size}"
                               :key="v.id"
                        >
                            <span>{{v.name}}</span>
                            <input type="checkbox" v-model="form.knowledges" :value="v.id" @change="getStock">
                        </label>
                    </template>
                </div>

                <p v-if="imageDictionary && !imageDictionary.length" class="no-knowledge">无可用知识点，请调整「设备型号」或「违禁品数量」</p>
            </div>
        </div>

        <!-- 练习模式 -->
        <div class="term-item">
            <div class="term-title">{{$t('stu.practiceMode')}}</div>
            <div class="term-content content-radio" style="flex:auto;flexGrow:0">
                <el-radio-group v-model="form.form" size="medium">
                    <el-radio-button :label="1">{{$t('stu.quickJudge')}}</el-radio-button>
                    <el-radio-button :label="2">{{$t('stu.markLocation')}}</el-radio-button>
                    <el-radio-button :label="3">{{$t('stu.markLocationAndJudge')}}</el-radio-button>
                </el-radio-group>
            </div>
        </div>

        <div class="term-item">
            <div class="term-title">{{$t('count.quantity')}}</div>
            <div class="item-count">
                <el-slider
                    v-model="form.count"
                    :min="0"
                    :max="stock"
                    :disabled="!stock"
                    show-input
                    :step="5"
                    show-stops
                    @change="sliderChange"
                >
                </el-slider>
                <p>/ <span style="font-size: 12px;">{{stock}}</span></p>
            </div>
        </div>

        <fiscan-paper
            v-model="fiscanPaper.show"
            :data="fiscanPaper.data"
            type="practice"
            :usage="1"
            :is-track="isTrack"
            @close="onFiscanClose"
        />
    </div>
</template>

<script>
/**
 * 职鉴练习模块，包含职鉴识图练习和职鉴走图
 */
import FiscanPaper from '@components/FiscanPaper';
import { mapGetters } from 'vuex';

export default {
    props: {
        // 是否为走图模式
        isTrack: {
            type: Boolean,
            default: false
        }
    },

    components: {
        FiscanPaper
    },

    data() {
        return {
            form: {
                productIds: [],
                isIdentification: true,
                tipCounts: [],
                knowledges: [],
                form: 1,
                count: 20,
            },
            stock: 100,
            imageDictionary: null,
            fiscanProductDropdown: [],
            tipCountDropdown: [1, 2, 3],
            fiscanPaper: {
                show: false,
                data: null,
            }
        }
    },

    computed: {
        ...mapGetters([
            'wsTrainee',
        ]),
    },

    mounted() {
        this.getStock()

        this.$api.getFiscanProduct().then(res => {
            this.fiscanProductDropdown = res.package
        })
    },

    methods: {
        startPractice() {
            if (!this.imageDictionary?.length) {
                this.$message.error('无可用知识点，请调整「设备型号」或「违禁品数量」')
                return Promise.reject()
            }

            const queryData = {
                ...this.form,
            }

            this.fiscanPaper.show = true

            return this.$api.startFiscanPractice(queryData).then(res => {
                this.fiscanPaper.data = Object.assign({}, res.package, {
                    form: this.form.form
                })

                // signalR:记录“练习”行为
                try {
                    this.wsTrainee.send('SJoinPractice')
                } catch (e) {
                    console.error(e)
                }

            }).catch((e) => {
                console.log(e)
                this.fiscanPaper.show = false
            })
        },

        getStock() {
            const data = {
                products: this.form.productIds,
                isIdentification: this.form.isIdentification,
                tipCounts: this.form.tipCounts,
                hideNodeIfZero: true  // 是否隐藏无库存知识点
            }

            this.$api.getFiscanImageStock(data).then(res => {
                this.imageDictionary = res.package
                this.removeEmptyKnowledgeSelected(this.imageDictionary)
            })
        },

        // 在选中的知识点中，过滤掉库存为0的知识点
        removeEmptyKnowledgeSelected(data) {
            if (!this.form.knowledges.length) return

            // 拍平所有知识点
            this.allKnowledgeFlat = []
            data.forEach(item => {
                this.allKnowledgeFlat = this.allKnowledgeFlat.concat(item.children)
            })

            // 过滤
            let finalKnowledges = []
            this.form.knowledges.forEach(id => {
                let item = this.allKnowledgeFlat.find(v => v.id === id)
                if (item && item.size !== 0) {
                    finalKnowledges.push(id)
                }
            })

            this.form.knowledges = finalKnowledges
        },

        onFiscanClose() {
            // signalR:记录“退出练习”行为
            this.wsTrainee.send('SLeavePractice')
        },

        sliderChange(val) {
            if (val % 1) {
                this.formSearch.count = Math.round(val);
            }
        }
    },
}
</script>

<style lang="scss">
.img-practice-fiscan {
    .danger-category {
        h5 {
            margin: 10px 0 10px 20px;
            padding-left: 8px;
            color: #666;
            font-size: 12px;
            border-left: 4px solid #ccc;
        }

        +.danger-category {
            margin-top: -10px;
        }
    }

    .no-knowledge {
        padding-top: 3px;
        padding-left: 30px;
        color: $red;
    }
}
</style>
